import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "components/core";

import ErrorMessage from "./error-message";

/**
 * This is displayed when there is an error or unhandled promise rejection
 * which React can continue rendering from i.e. the class of errors *not*
 * handled by the error boundary.
 */
const ErrorDialog = ({ open, onClose, ...rest }) => {
  const [copyVersion, setCopyVersion] = useState(null);

  useEffect(() => {
    if (open) {
      setCopyVersion(Math.floor(Math.random() * 3));
    }
  }, [open]);

  return (
    <Dialog maxWidth="sm" open={open} onClose={onClose} {...rest}>
      <DialogTitle sx={{ justifyContent: "flex-end", display: "flex" }}>
        <IconButton
          aria-label="Close"
          sx={{ mt: "-2px", mr: "-8px" }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ py: 8, px: [3, 4], textAlign: "center" }}>
        {copyVersion !== null && <ErrorMessage version={copyVersion} />}
      </DialogContent>
    </Dialog>
  );
};

ErrorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ErrorDialog;
